import Bowser from 'bowser'
import onMomentum from './onMomentum'

var browser = Bowser.parse(window.navigator.userAgent)

export default function ($element) {
  var data = {
    rate: 0.4,
    delta: 1,
    autoplay: true,
    offset: 0,
    position: 0,
    rafInstance: null,
    momentumInstance: null
  }

  function tick () {
    setPositions() // set column positions on each tick
    data.rafInstance = window.requestAnimationFrame(tick)
  }

  function setPositions () {
    var $measure = $element.querySelector('[data-measure]')
    if (!$measure) return

    var height = $measure.offsetHeight
    var position = data.position || data.offset
    var adjustedDelta = data.autoplay ? data.delta : (Math.abs(data.delta) === 1 ? 0 : data.delta)
    position += -1 * adjustedDelta * data.rate  
    var newPosition = position
    if (data.delta > 0) {
      // reset to top when we've translated too far past bottom
      if (Math.abs(newPosition) >= height) {
        var offset = newPosition + height
        position = offset
      }
    } else if (data.delta < 0) {
      // reset to bottom of clone when we've translated too far past top
      if (newPosition > 0) {
        var offset = height + newPosition
        position = -1 * offset
      }
    }
    data.position = position
    $element.style.transform = `translate3d(0,${data.position}px,0)`
  }

  /**
   * Public
   */

  function init () {
    data.momentumInstance = onMomentum({
      callback: delta => {
        data.delta = delta
      },
      touchSource: $element,
      scrollSource: browser.os.name === 'iOS' 
        ? $element 
        : window
    }).start()
    // init animation frame
    data.rafInstance = window.requestAnimationFrame(tick)
  }

  function destroy () {
    if (data.momentumInstance) {
      data.momentumInstance.stop()
    }
    if (data.rafInstance) {
      window.cancelAnimationFrame(data.rafInstance)
      $element.style.transform = `translate3d(0,0,0)`
    }
  }

  return {
    'init' : init,
    'destroy' : destroy
  }
}